import React from 'react'
import { makeStyles } from '@material-ui/core'
import { Icon } from '../../../components'
import jss from './style'

const useStyles = makeStyles(jss)

const iconSize = {
    small: 12,
    medium: 14,
    large: 20,
    'extra-large': 32
}

/**
 *
 */
export const sizes = {
    small: 18,
    medium: 22,
    large: 28,
    'extra-large': 44
}

interface PropsInterface {
    value?: boolean,
    size?: 'small' | 'medium' | 'large' | 'extra-large',
    className?: string,
    onClick?: () => any,
    style?: React.CSSProperties,
    variant?: 'contained' | 'icon';
    color?: string,
    bgColor?: string,
    'data-testid'?: string

}

/**
 *
 */
const FavoriteIconButton = ({
    value = false,
    size = 'medium',
    className,
    onClick,
    style = {},
    variant = 'icon',
    color = '#EBCB00',
    bgColor,
    'data-testid': dataTestId = 'favorite-toggle'

}: PropsInterface): JSX.Element => {
    const styles = useStyles({ variant, bgColor })
    const iconName = value ? 'star-filled' : 'star-outlined'

    return <div
        className={`${styles.favorite} ${className || ''}`}
        style={{
            width: `${sizes[size]}px`,
            height: `${sizes[size]}px`,
            minHeight: `${sizes[size]}px`,
            minWidth: `${sizes[size]}px`,
            ...style
        }}
        onClick={onClick}
        data-testid={dataTestId}
    >
        <Icon
            name={iconName}
            size={iconSize[size]}
            color={color}
            data-testid={`${dataTestId}-${iconName}`}
        />
    </div>
}

export default FavoriteIconButton
